/**
 * playerStore.js  —  Vuex module for the global audio player
 *
 * Register in store/index.js:
 *   import playerStore from './playerStore'
 *   modules: { player: playerStore }
 */
export default {
  namespaced: true,
  state: () => ({
    currentIndex:    -1,       // index of the playing card in publicationList
    publicationList: [],       // mirror of Publications' list for GlobalPlayer meta
    currentTime:     0,        // updated by Publication every ~80ms while playing
    duration:        0,
    isPlaying:       false,
    meta: { userName: '', userAvatar: '', text: '', img: '', imgMini: '' },
    featuredPub: null
  }),
  mutations: {
    setCurrentIndex    (state, v) { state.currentIndex    = v },
    setPublicationList (state, v) { state.publicationList = v },
    setCurrentTime     (state, v) { state.currentTime     = v },
    setDuration        (state, v) { state.duration        = v },
    setIsPlaying       (state, v) { state.isPlaying       = v },
    setMeta            (state, v) { state.meta = { ...state.meta, ...v } },
    setFeaturedPub (state, v) { state.featuredPub = v }
  },
  getters: {
    isActive:   state => state.isPlaying,
    progress:   state => state.duration > 0 ? state.currentTime / state.duration : 0,
    currentPub: state => state.publicationList[state.currentIndex] ?? null,
  },
}